import request from '@/utils/request';
import { newHost } from '@/global-config';

/**
 * 费用明细列表查询
 * */
export function queryCostList(data) {
  return request({
    url: '/costDetail/pageQuery',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

export function queryCostDetail(data) {
  return request({
    url: '/costDetail/singleDetailQuery',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

export function exportCostDetail(data) {
  return request({
    url: '/costDetail/export',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/**
 * 判断商户结算类型
 * query sessionId
 * return data true: D0商户， false:非D0商户
 * */
export function getMerchantType(data) {
  return request({
    url: '/costDetail/d0Merchant',
    method: 'get',
    data,
    baseURL: newHost,
  });
}

// 获取费用明细表头
export function getFieldConfig(params) {
  return request({
    url: '/costDetail/getFieldConfig',
    method: 'post',
    params,
    baseURL: newHost,
  });
}

// 设置费用明细表头
export function setFieldConfig(data) {
  return request({
    url: '/costDetail/setFieldConfig',
    method: 'post',
    data,
    baseURL: newHost,
  });
}
